export default "__VITE_ASSET__R8ONKFLH__"